(function ($) {

    // Animated stats block
    $('.animated-counter').counterUp({
        //delay: 10,
        beginAt: 0,
        offset: 98,
        time: 2000,
    });

}(jQuery));